import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import { House, Apartment, Sell } from "@mui/icons-material"; // Icone MUI
import { Link } from "react-router-dom";

// Componente principale per la sezione
const RealEstateServices = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box
      sx={{
        padding: 6,
        backgroundColor: isMobile ? "#0c6b8b" : "#c9c9c9",
        mb: 3,
      }}
    >
      {/* Titolo principale della sezione */}
      <Typography
        sx={{
          fontSize: isMobile ? "28px" : undefined,
          fontFamily: "ivymode",
          fontStyle: isMobile ? "italic" : undefined,
          color: isMobile ? "white" : "#3d3d3d",
        }}
        variant="h3"
        gutterBottom
      >
        Come funzionano i nostri servizi
      </Typography>
      <Typography
        variant="body1"
        paragraph
        sx={{
          fontSize: "18px",
          maxWidth: 800,
          color: isMobile ? "white" : "#3d3d3d",
        }}
      >
        Offriamo una gamma completa di servizi per soddisfare le tue esigenze
        immobiliari, che tu stia cercando di valutare, affittare o vendere un
        immobile. Scopri come possiamo aiutarti a ottenere i migliori risultati.
      </Typography>

      {/* Layout Grid per disporre le card */}
      <Grid container spacing={4} justifyContent="center" paddingTop={4}>
        {/* Sezione Valutazione Immobile */}
        <Grid item xs={12} sm={4}>
          <Card sx={{ height: "100%", boxShadow: 5, borderRadius: 3 }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 2,
                }}
              >
                <House
                  sx={{ fontSize: 40, color: "#3d3d3d", marginRight: 2 }}
                />
                <Typography variant="h5" component="div">
                  Valutazione Immobile
                </Typography>
              </Box>
              <Divider sx={{ marginBottom: 2 }} />
              <Typography variant="body1" paragraph>
                Valutiamo il tuo immobile con metodi accurati e professionali
                per determinare il suo valore di mercato. Utilizziamo dati di
                mercato aggiornati, comparazioni con immobili simili e
                l'esperienza del nostro team di esperti per fornirti una
                valutazione realistica e precisa. Sia che tu stia pensando di
                vendere o affittare, una valutazione professionale è il primo
                passo fondamentale.
              </Typography>

              {/* Aggiunta degli step per il processo di valutazione immobile */}
              <Typography variant="h7" paragraph>
                Ecco come funziona il nostro processo di valutazione:
              </Typography>
              <List>
                <ListItem>
                  <ListItemText
                    primary="Step 1: Ispezione dell'immobile"
                    secondary="Visitiamo il tuo immobile per raccogliere informazioni dettagliate sulla sua condizione e caratteristiche."
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Step 2: Analisi di mercato"
                    secondary="Esaminiamo i dati di mercato più recenti, comprese le vendite e gli affitti di immobili simili nella tua zona."
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Step 3: Report e valutazione"
                    secondary="Forniremo un report dettagliato con la valutazione del tuo immobile e suggerimenti su come massimizzare il suo valore."
                  />
                </ListItem>
              </List>

              <Button
                component={Link} // Usa Link per fare navigazione
                to="/contattaci" // Imposta il percorso di destinazione
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                  width: isMobile ? "250px" : undefined,
                  margin: "0 auto",
                  backgroundColor: "#0C6D8D",
                }}
              >
                Contattaci{" "}
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Sezione Affitto Immobile */}
        <Grid item xs={12} sm={4}>
          <Card sx={{ height: "100%", boxShadow: 5, borderRadius: 3 }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 2,
                }}
              >
                <Apartment
                  sx={{ fontSize: 40, color: "#1184aa", marginRight: 2 }}
                />
                <Typography variant="h5" component="div">
                  Affitto Immobile
                </Typography>
              </Box>
              <Divider sx={{ marginBottom: 2 }} />
              <Typography variant="body1" paragraph>
                Ti offriamo una gestione completa degli affitti, dalla ricerca
                degli inquilini ideali alla stipula del contratto e alla
                gestione quotidiana. Se sei un proprietario che desidera
                affittare un immobile, ci occupiamo di tutte le pratiche legali
                e amministrative, garantendo una gestione semplice e sicura. Ti
                aiutiamo a ottenere il massimo profitto dalla tua proprietà.
              </Typography>

              {/* Aggiunta degli step per il processo di affitto immobile */}
              <Typography variant="h7" paragraph>
                Ecco come funziona il nostro processo di affitto:
              </Typography>
              <List>
                <ListItem>
                  <ListItemText
                    primary="Step 1: Analisi del mercato"
                    secondary="Studiamo la domanda di affitto nella tua zona per determinare il prezzo ideale."
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Step 2: Ricerca degli inquilini"
                    secondary="Pubblicizziamo l'immobile e selezioniamo gli inquilini più affidabili.Pubblicizziamo l'immobile."
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Step 3: Contratto e gestione"
                    secondary="Stipuliamo il contratto di affitto, gestiamo i pagamenti e l'assistenza continua per tutta la durata del contratto."
                  />
                </ListItem>
              </List>

              <Button
                component={Link} // Usa Link per fare navigazione
                to="/contattaci" // Imposta il percorso di destinazione
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                  width: isMobile ? "250px" : undefined,

                  backgroundColor: "#0C6D8D",
                }}
              >
                Contattaci{" "}
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Sezione Vendita Immobile */}
        <Grid item xs={12} sm={4}>
          <Card sx={{ height: "100%", boxShadow: 3, borderRadius: 3 }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 2,
                }}
              >
                <Sell sx={{ fontSize: 40, color: "#ff9800", marginRight: 2 }} />
                <Typography variant="h5" component="div">
                  Vendita Immobile
                </Typography>
              </Box>
              <Divider sx={{ marginBottom: 2 }} />
              <Typography variant="body1" paragraph>
                Se desideri vendere il tuo immobile, il nostro team di esperti
                ti guiderà in ogni fase del processo, dalla valutazione iniziale
                alla negoziazione finale. Ci occupiamo della pubblicità, della
                promozione, e della gestione delle visite, garantendo che il
                processo di vendita sia rapido, sicuro e vantaggioso per te. Il
                nostro obiettivo è vendere il tuo immobile al miglior prezzo
                possibile.
              </Typography>

              {/* Aggiunta degli step per il processo di vendita immobile */}
              <Typography variant="h7" paragraph>
                Ecco come funziona il nostro processo di vendita:
              </Typography>
              <List>
                <ListItem>
                  <ListItemText
                    primary="Step 1: Valutazione dell'immobile"
                    secondary="Esaminiamo il valore del tuo immobile, tenendo conto della posizione, delle caratteristiche e delle condizioni di mercato."
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Step 2: Promozione e pubblicità"
                    secondary="Creiamo strategie pubblicitarie su piattaforme online, social media, e marketing tradizionale."
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Step 3: Negoziazione e vendita"
                    secondary="Gestiamo le trattative e aiutiamo a ottenere il miglior prezzo possibile, occupandoci anche di tutte le pratiche legali."
                  />
                </ListItem>
              </List>

              <Button
                component={Link} // Usa Link per fare navigazione
                to="/contattaci" // Imposta il percorso di destinazione
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                  width: isMobile ? "250px" : undefined,

                  backgroundColor: "#0C6D8D",
                }}
              >
                Contattaci{" "}
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Separatore aggiuntivo per un aspetto più pulito */}
      <Box sx={{ marginTop: 6, textAlign: "center" }}>
        <Typography variant="h6" sx={{ color: isMobile ? "white" : "#3d3d3d" }}>
          Ogni immobile è unico, e ogni cliente ha esigenze diverse. Se non
          trovi il servizio che stai cercando, non esitare a contattarci. Siamo
          qui per aiutarti a ottenere il massimo dal tuo investimento
          immobiliare!
        </Typography>
      </Box>
    </Box>
  );
};

export default RealEstateServices;
